const translateField = (language?: string, restaurantLanguage?: string, fieldValues?: TranslatableValues): string => {
  return (
    (language && fieldValues?.[language]) ||
    fieldValues?.en ||
    (restaurantLanguage && fieldValues?.[restaurantLanguage]) ||
    Object.values(fieldValues ?? {}).filter((val) => !!val)[0] ||
    undefined
  )
}

const AVAILABLE_LANGUAGES = [
  'fr',
  'en',
  'es',
  'de',
  'it',
  'pt',
  'nl',
  'no',
  'sv',
  'da'
] as const satisfies AvailableLanguages[]

const isAvailableLanguage = (lang: string): lang is AvailableLanguages =>
  AVAILABLE_LANGUAGES.includes(lang as AvailableLanguages)

type LocaleDate = typeof import('date-fns/locale/en')

export type { LocaleDate }
export { AVAILABLE_LANGUAGES, isAvailableLanguage, translateField }
